import script from "./roadtaxPage.vue?vue&type=script&setup=true&lang=js"
export * from "./roadtaxPage.vue?vue&type=script&setup=true&lang=js"

import "./roadtaxPage.vue?vue&type=style&index=0&id=2563744d&lang=css"

const __exports__ = script;

export default __exports__